import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import "./index.css";
import "./components/header.css";
import "./assets/font/stylesheet.css";
import MainModal from "./pages/Fytn/MainModal";
import ReportPage from "./pages/Reports/ReportPage";
import AuthForm from "./pages/Fytn/components/Auth/Login";
import Dashboard from "./pages/Fytn/components/Dashboard";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import AdminRoute from "./PrivateRoute/AdminRoute";
import VerifyToken from "./pages/Fytn/components/VerifyToken";
import { SnackbarManager } from "./components/ModernSnackbar";
import MainModalNew from "./pages/Fytn/MainModalNew";
import ThankYouPage from "./pages/Fytn/components/ThankYou";
import NotFoundPage from "./pages/Fytn/components/NotFound";
// import Report from "./components/report-components/Report";
import SignupForm from "./pages/Fytn/components/Auth/Signup";
import DashboardNew from "./pages/Fytn/components/DashboardNew/Dashboard";
import ReportPagePDF from "./components/PDF-components/ReportPage";

import ResetPassword from "./pages/Fytn/components/Auth/ResetPassword";
import DashboardTabs from "./pages/Fytn/components/DashboardTabs";
import DashboardRoute from "./PrivateRoute/DashboardRoute";

function App() {
  const [user, setUser] = useState(null);
  const [reload, setReload] = useState(false);
  // console.log = () => {};

  let defaultRouteRedirect = null;

  if (process.env.NODE_ENV === "production") {
    const hostname = window.location.hostname;
    if (hostname === "viptest.findyourtruenorth.co.in") {
      defaultRouteRedirect = <Navigate to="/test" replace />;
    } else if (hostname === "app.findyourtruenorth.co.in") {
      defaultRouteRedirect = <Navigate to="/login" replace />;
    }
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={defaultRouteRedirect} />
          <Route path="/login" element={<AuthForm />} />
          <Route path="/signup" element={<SignupForm />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          <Route
            path="/dashboard"
            element={<DashboardRoute element={<PrivateRoute element={<DashboardTabs reload={reload} />} />} />}
          />
          <Route
            path="/admin"
            element={<AdminRoute element={<DashboardTabs reload={reload} />} />}
          />
          <Route path="/yourresults" element={<ReportPage />} />
          <Route
            path="/test-new/:token"
            element={<VerifyToken setUser={setUser} user={user} />}
          />
          <Route path="/test" element={<MainModal />} />
          <Route
            path="/test-new"
            element={<MainModalNew user={user} setReload={setReload} />}
          />
          <Route path="/thank-you" element={<ThankYouPage />} />

          <Route path="/report" element={<ReportPagePDF />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>

      <SnackbarManager />
    </>
  );
}

export default App;
